import { render, staticRenderFns } from "./FormResult.vue?vue&type=template&id=1f9ef821&"
import script from "./FormResult.vue?vue&type=script&lang=js&"
export * from "./FormResult.vue?vue&type=script&lang=js&"
import style0 from "./FormResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports